export const SiteIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
      <path
        d='M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9ZM6.01481 9.75H3.04642C3.33256 12.0447 4.91451 13.937 7.0369 14.6715C6.47274 13.4499 6.0927 11.7111 6.01481 9.75ZM7.51608 9.75C7.58573 11.3625 7.87567 12.7569 8.27139 13.7462C8.50101 14.3202 8.7369 14.6841 8.9221 14.88C8.95235 14.9119 8.97833 14.9366 9 14.9555C9.02168 14.9366 9.04765 14.9119 9.0779 14.88C9.2631 14.6841 9.49899 14.3202 9.72861 13.7462C10.1243 12.7569 10.4143 11.3625 10.4839 9.75H7.51608ZM10.4839 8.25C10.4143 6.63751 10.1243 5.2431 9.72861 4.25379C9.49899 3.67976 9.2631 3.31588 9.0779 3.12005C9.04765 3.08806 9.02168 3.06338 9 3.04447C8.97832 3.06338 8.95235 3.08806 8.9221 3.12005C8.7369 3.31588 8.50101 3.67976 8.27139 4.25379C7.87567 5.2431 7.58573 6.63751 7.51608 8.25H10.4839ZM11.9852 9.75C11.9073 11.7111 11.5273 13.4499 10.9631 14.6715C13.0855 13.937 14.6674 12.0447 14.9536 9.75H11.9852ZM14.9536 8.25C14.6674 5.9553 13.0855 4.06302 10.9631 3.3285C11.5273 4.55005 11.9073 6.28892 11.9852 8.25H14.9536ZM3.04642 8.25H6.01481C6.0927 6.28892 6.47274 4.55005 7.0369 3.3285C4.91451 4.06302 3.33256 5.9553 3.04642 8.25Z'
        fill='#ACAEB1'
      />
    </svg>
  );
};

export const PeopleIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
      <path
        d='M6.75038 2.25146C4.88729 2.25146 3.37695 3.7618 3.37695 5.62489C3.37695 7.48799 4.88729 8.99832 6.75038 8.99832C8.61347 8.99832 10.1238 7.48799 10.1238 5.62489C10.1238 3.7618 8.61347 2.25146 6.75038 2.25146ZM4.87381 5.62489C4.87381 4.58849 5.71398 3.74832 6.75038 3.74832C7.78678 3.74832 8.62695 4.58849 8.62695 5.62489C8.62695 6.66129 7.78678 7.50146 6.75038 7.50146C5.71398 7.50146 4.87381 6.66129 4.87381 5.62489Z'
        fill='#ACAEB1'
      />
      <path
        d='M4.50038 9.75146C2.8444 9.75146 1.50195 11.0939 1.50195 12.7499V15.7483H11.9988V12.7499C11.9988 11.0939 10.6564 9.75146 9.00038 9.75146H4.50038ZM2.99881 12.7499C2.99881 11.9206 3.67109 11.2483 4.50038 11.2483H9.00038C9.82968 11.2483 10.502 11.9206 10.502 12.7499V14.2515H2.99881V12.7499Z'
        fill='#ACAEB1'
      />
      <path
        d='M10.5005 7.125C10.5005 5.88236 11.5078 4.875 12.7505 4.875C13.9931 4.875 15.0005 5.88236 15.0005 7.125C15.0005 8.36764 13.9931 9.375 12.7505 9.375C11.5078 9.375 10.5005 8.36764 10.5005 7.125ZM12.7505 6.375C12.3363 6.375 12.0005 6.71079 12.0005 7.125C12.0005 7.53921 12.3363 7.875 12.7505 7.875C13.1647 7.875 13.5005 7.53921 13.5005 7.125C13.5005 6.71079 13.1647 6.375 12.7505 6.375Z'
        fill='#ACAEB1'
      />
      <path
        d='M16.5005 15H12.7505V13.5H15.0005V12.7031C15.0005 12.263 14.6437 11.9062 14.2036 11.9062H12.7505V10.4062H14.2036C15.4721 10.4062 16.5005 11.4346 16.5005 12.7031V15Z'
        fill='#ACAEB1'
      />
    </svg>
  );
};

export const BuildingIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
      <path d='M5.25 8.25H9V9.75H5.25V8.25Z' fill='#ACAEB1' />
      <path d='M5.25 11.25H9V12.75H5.25V11.25Z' fill='#ACAEB1' />
      <path
        d='M11.9964 16.5L12 16.5H14.25C15.4926 16.5 16.5 15.4926 16.5 14.25V7.82581C16.5 6.93799 15.9779 6.13317 15.1672 5.77125L12.6115 4.6303C12.4161 4.54306 12.2077 4.49999 12 4.5V4.0045C12 2.5005 10.5528 1.41994 9.1108 1.8472L3.8608 3.40276C2.90541 3.68584 2.25 4.5636 2.25 5.56005V14.25C2.25 15.4927 3.25736 16.5 4.5 16.5H10.5C10.504 16.5 10.508 16.5 10.512 16.5H11.9964ZM12 6L14.5557 7.14096C14.826 7.2616 15 7.52987 15 7.82581V14.25C15 14.6642 14.6642 15 14.25 15H12V6ZM10.5 15H4.5C4.08579 15 3.75 14.6643 3.75 14.25V5.56005C3.75 5.2279 3.96847 4.93532 4.28693 4.84096L9.53693 3.2854C10.0176 3.14298 10.5 3.50317 10.5 4.0045V15Z'
        fill='#ACAEB1'
      />
    </svg>
  );
};

export const FinancingIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
      <path
        d='M9.00011 3C6.62852 3 4.57694 4.37642 3.60305 6.375H9.00027C9.17057 6.375 9.3358 6.43296 9.46879 6.53935L11.3438 8.03935L10.4067 9.21065L8.73718 7.875H2.51394C2.27825 7.875 2.05627 7.76421 1.91458 7.57586C1.7729 7.38751 1.728 7.14351 1.79334 6.91706C2.696 3.78894 5.57978 1.5 9.00011 1.5C12.4205 1.5 15.3042 3.78894 16.2069 6.91706C16.3217 7.31504 16.0922 7.73076 15.6942 7.8456C15.2963 7.96044 14.8805 7.73091 14.7657 7.33294C14.0433 4.82963 11.7344 3 9.00011 3Z'
        fill='#ACAEB1'
      />
      <path
        d='M9.00004 15C11.3716 15 13.4232 13.6236 14.3971 11.625H8.99989C8.82958 11.625 8.66435 11.567 8.53137 11.4607L6.65637 9.96065L7.59341 8.78935L9.26297 10.125H15.4862C15.7219 10.125 15.9439 10.2358 16.0856 10.4241C16.2273 10.6125 16.2722 10.8565 16.2068 11.0829C15.3042 14.2111 12.4204 16.5 9.00004 16.5C5.5797 16.5 2.69593 14.2111 1.79327 11.0829C1.67843 10.685 1.90795 10.2692 2.30593 10.1544C2.7039 10.0396 3.11962 10.2691 3.23446 10.6671C3.95682 13.1704 6.26574 15 9.00004 15Z'
        fill='#ACAEB1'
      />
    </svg>
  );
};

export const MediaIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
      <rect
        x='2.25'
        y='3.375'
        width='13.5'
        height='11.25'
        rx='0.75'
        stroke='#ACAEB1'
        strokeWidth='1.5'
      />
      <path
        d='M11.4823 8.74574C11.4882 8.74918 11.4909 8.75176 11.492 8.75287C11.4932 8.75409 11.4942 8.75537 11.4951 8.75708C11.4972 8.76094 11.5 8.76871 11.5 8.77956C11.5 8.79041 11.4972 8.79818 11.4951 8.80204C11.4942 8.80374 11.4932 8.80503 11.492 8.80625C11.4909 8.80735 11.4882 8.80994 11.4823 8.81337L7.04281 11.3999L7.39975 12.0125L7.04281 11.3999C7.03691 11.4033 7.03372 11.4042 7.03306 11.4043C7.03226 11.4045 7.03182 11.4046 7.03129 11.4046C7.02985 11.4045 7.02469 11.4039 7.01767 11.3999C7.01065 11.3958 7.00626 11.3908 7.00412 11.3872C7.00315 11.3855 7.00234 11.3837 7.00168 11.3814C7.00105 11.3791 7 11.3743 7 11.366L7 6.19307C7 6.18478 7.00105 6.18001 7.00168 6.17776C7.00234 6.17537 7.00315 6.17358 7.00412 6.17195C7.00626 6.16835 7.01065 6.16334 7.01767 6.15925C7.02469 6.15517 7.02985 6.15458 7.03129 6.15456C7.03182 6.15455 7.03226 6.15458 7.03306 6.15479C7.03372 6.15496 7.03691 6.15582 7.04281 6.15925L11.4823 8.74574Z'
        stroke='#ACAEB1'
        strokeWidth='1.5'
      />
    </svg>
  );
};

export const FBIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M20 12C20 7.6 16.4 4 12 4C7.6 4 4 7.6 4 12C4 16 6.9 19.3 10.7 19.9V14.3H8.7V12H10.7V10.2C10.7 8.2 11.9 7.1 13.7 7.1C14.6 7.1 15.5 7.3 15.5 7.3V9.3H14.5C13.5 9.3 13.2 9.9 13.2 10.5V12H15.4L15 14.3H13.1V20C17.1 19.4 20 16 20 12Z'
        fill='#4B4C4D'
      />
    </svg>
  );
};

export const LinkedIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M7.60001 20H4.2V9.3H7.60001V20ZM5.9 7.8C4.8 7.8 4 7 4 5.9C4 4.8 4.9 4 5.9 4C7 4 7.8 4.8 7.8 5.9C7.8 7 7 7.8 5.9 7.8ZM20 20H16.6V14.2C16.6 12.5 15.9 12 14.9 12C13.9 12 12.9 12.8 12.9 14.3V20H9.5V9.3H12.7V10.8C13 10.1 14.2 9 15.9 9C17.8 9 19.8 10.1 19.8 13.4V20H20Z'
        fill='#4B4C4D'
      />
    </svg>
  );
};

export const InstagramIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M12 5.44581C14.1205 5.44581 14.4096 5.44581 15.2771 5.44581C16.0482 5.44581 16.4337 5.63858 16.7229 5.73496C17.1084 5.92773 17.3976 6.02412 17.6867 6.31328C17.9759 6.60243 18.1687 6.89159 18.2651 7.27713C18.3614 7.56629 18.4578 7.95183 18.5542 8.72292C18.5542 9.59039 18.5542 9.78316 18.5542 12C18.5542 14.2169 18.5542 14.4097 18.5542 15.2771C18.5542 16.0482 18.3614 16.4338 18.2651 16.7229C18.0723 17.1085 17.9759 17.3976 17.6867 17.6868C17.3976 17.9759 17.1084 18.1687 16.7229 18.2651C16.4337 18.3615 16.0482 18.4579 15.2771 18.5542C14.4096 18.5542 14.2169 18.5542 12 18.5542C9.78313 18.5542 9.59036 18.5542 8.72289 18.5542C7.95181 18.5542 7.56627 18.3615 7.27711 18.2651C6.89157 18.0723 6.60241 17.9759 6.31325 17.6868C6.0241 17.3976 5.83133 17.1085 5.73494 16.7229C5.63855 16.4338 5.54217 16.0482 5.44578 15.2771C5.44578 14.4097 5.44578 14.2169 5.44578 12C5.44578 9.78316 5.44578 9.59039 5.44578 8.72292C5.44578 7.95183 5.63855 7.56629 5.73494 7.27713C5.92771 6.89159 6.0241 6.60243 6.31325 6.31328C6.60241 6.02412 6.89157 5.83135 7.27711 5.73496C7.56627 5.63858 7.95181 5.54219 8.72289 5.44581C9.59036 5.44581 9.87952 5.44581 12 5.44581ZM12 4.00002C9.78313 4.00002 9.59036 4.00002 8.72289 4.00002C7.85542 4.00002 7.27711 4.19279 6.79518 4.38557C6.31325 4.57834 5.83133 4.86749 5.3494 5.34942C4.86747 5.83135 4.6747 6.21689 4.38554 6.7952C4.19277 7.27713 4.09639 7.85545 4 8.72292C4 9.59039 4 9.87954 4 12C4 14.2169 4 14.4097 4 15.2771C4 16.1446 4.19277 16.7229 4.38554 17.2048C4.57831 17.6868 4.86747 18.1687 5.3494 18.6506C5.83133 19.1326 6.21687 19.3253 6.79518 19.6145C7.27711 19.8073 7.85542 19.9036 8.72289 20C9.59036 20 9.87952 20 12 20C14.1205 20 14.4096 20 15.2771 20C16.1446 20 16.7229 19.8073 17.2048 19.6145C17.6867 19.4217 18.1687 19.1326 18.6506 18.6506C19.1325 18.1687 19.3253 17.7832 19.6145 17.2048C19.8072 16.7229 19.9036 16.1446 20 15.2771C20 14.4097 20 14.1205 20 12C20 9.87954 20 9.59039 20 8.72292C20 7.85545 19.8072 7.27713 19.6145 6.7952C19.4217 6.31328 19.1325 5.83135 18.6506 5.34942C18.1687 4.86749 17.7831 4.67472 17.2048 4.38557C16.7229 4.19279 16.1446 4.09641 15.2771 4.00002C14.4096 4.00002 14.2169 4.00002 12 4.00002Z'
        fill='#4B4C4D'
      />
      <path
        d='M12 7.85544C9.68675 7.85544 7.85542 9.68677 7.85542 12C7.85542 14.3133 9.68675 16.1446 12 16.1446C14.3133 16.1446 16.1446 14.3133 16.1446 12C16.1446 9.68677 14.3133 7.85544 12 7.85544ZM12 14.6988C10.5542 14.6988 9.30121 13.5422 9.30121 12C9.30121 10.5542 10.4578 9.30123 12 9.30123C13.4458 9.30123 14.6988 10.4579 14.6988 12C14.6988 13.4458 13.4458 14.6988 12 14.6988Z'
        fill='#4B4C4D'
      />
      <path
        d='M16.241 8.72292C16.7733 8.72292 17.2048 8.29138 17.2048 7.75906C17.2048 7.22674 16.7733 6.7952 16.241 6.7952C15.7086 6.7952 15.2771 7.22674 15.2771 7.75906C15.2771 8.29138 15.7086 8.72292 16.241 8.72292Z'
        fill='#4B4C4D'
      />
    </svg>
  );
};

export const YuTuBeIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M19.6 8.10006C19.4 7.40006 18.9 6.90006 18.2 6.70006C17 6.40006 11.9 6.40005 11.9 6.40005C11.9 6.40005 6.90001 6.40006 5.60001 6.70006C4.90001 6.90006 4.4 7.40006 4.2 8.10006C4 9.40006 4 12.0001 4 12.0001C4 12.0001 4 14.6001 4.3 15.9001C4.5 16.6001 5 17.1001 5.7 17.3001C6.9 17.6001 12 17.6001 12 17.6001C12 17.6001 17 17.6001 18.3 17.3001C19 17.1001 19.5 16.6001 19.7 15.9001C20 14.6001 20 12.0001 20 12.0001C20 12.0001 20 9.40006 19.6 8.10006ZM10.4 14.4001V9.60006L14.6 12.0001L10.4 14.4001Z'
        fill='#4B4C4D'
      />
    </svg>
  );
};

export const XIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M6.04139 6.42857H9.86453L12.5795 10.1474L15.8739 6.42857H17.0781L13.1232 10.8919L18 17.5714H14.1778L11.0273 13.2568L7.20414 17.5714H6L10.4835 12.5123L6.04139 6.42857ZM7.88523 7.35715L14.6802 16.6429H16.1562L9.36124 7.35715H7.88523Z'
        fill='#4B4C4D'
      />
    </svg>
  );
};
